import httpService from '@/utils/request'
import { contextPath } from '@/config/'

// 首页概览-总站点数
export const getBaseInfoSpiderNumApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statSpiderNum',
    method: 'get',
    params
  })
}

// 首页概览-采集总数
export const getBaseInfoSpiderResultNumApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statSpiderResultNum',
    method: 'get',
    params
  })
}

// 首页概览-任务数
export const getBaseInfoSpiderTaskNumApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statSpiderTaskNum',
    method: 'get',
    params
  })
}

// 节点状态
export const getStatServerApi = (params) => {
  return httpService({
    url: contextPath + '/system/server/item/statServer',
    method: 'get',
    params
  })
}

// 今日调度任务
export const getStatTaskNumByTodayApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statTaskNumByToday',
    method: 'get',
    params
  })
}

// 异常调度任务详情
export const getStatTaskErrorApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statTaskError',
    method: 'get',
    params
  })
}

// 异常站点详情
export const getStatSpiderErrorApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statSpiderError',
    method: 'get',
    params
  })
}

// 实时采集
export const getCollectionFlowApi = (params) => {
  return httpService({
    url: '/spider-admin/static/media',
    method: 'get',
    params
  })
}

// 实时采集流量
export const getCrawlFlowApi = (params) => {
  return httpService({
    url: '/spider-admin/static/spider/flow',
    method: 'get',
    params
  })
}

//采集国家结果
export const getCrawlCountryApi = (params) => {
  return httpService({
    url: '/spider-admin/static/country',
    method: 'get',
    params
  })
}

//采集国家结果
export const getCrawlLangApi = (params) => {
  return httpService({
    url: '/spider-admin/static/lang',
    method: 'get',
    params
  })
}

//当日采集量排行
export const getCrawlRankApi = (params) => {
  return httpService({
    url: '/spider-admin/static/spider/rank',
    method: 'get',
    params
  })
}

//当日文件采集的类型
export const getCrawlFileTypeTodayApi = (params) => {
  return httpService({
    url: contextPath + '/spider/stat/item/statSpiderFileTypeToday',
    method: 'get',
    params
  })
}





